export class XauditModel {
  xauditCreatedBy: string;
  xauditCreatedOn: Date;
  xauditDeleted: boolean;
  xauditModifiedBy: string;
  xauditModifiedOn: Date;
  xauditTableRowID: string;
}
